import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import Footer from '../../../rows/new-footer/new-footer';
import Faqs from '../faqs/faqs';
import Pricing from '../pricing/pricing';
import ResearchReports from '../research-reports/research.reports';
import './../subscribe/subscribe.m.css';

import MobileBottomSticky from '../../../molecules/mobile-bottom-sticky';
import PremiumStories from '../premium-stories';
import SubscriptionNavbar from '../subscription-navbar';
import SubscriptionOffer from '../subscription-offer';

const SubscriptionOfferPage = ({ faq, terms, features, ...props }) => {
  const [premium, setPremium] = useState(null);
  const isSubscriber = useSelector((state) => get(state, ['userData', 'isSubscriber'], null));
  const [isMenu, setMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const filterList = faq?.items?.filter(
    (_, index) =>
      index !==
      faq?.items?.findIndex((item) => item?.question === features?.subscription_offer?.hideFaq),
  );

  const faqList = { items: filterList };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.addEventListener('message', function (evt) {
      if (evt.data && evt.data === 'openSupport') {
        const contactForm = document.getElementById('contact-btn');
        contactForm.click();
      }
    });
  }, [terms]);

  useEffect(() => {
    const sotries = async () => {
      await fetch('/api/v1/collections/premium?item-type=story')
        .then((res) => res.json())
        .then((res) => {
          setPremium(res);
        });
    };
    sotries();
  }, []);
  const restoreScrollAfterLazyLoad = () => {
    let lastScrollY = window.scrollY;

    const observer = new MutationObserver(() => {
      window.scrollTo(0, lastScrollY);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('scroll', () => {
      lastScrollY = window.scrollY;
    });

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', () => {
        lastScrollY = window.scrollY;
      });
    };
  };
  useEffect(restoreScrollAfterLazyLoad, []);
  const hideShowMobileMenu = (value) => {
    setMenu(value);
  };
  const [isAmpPage, setAmpPage] = useState(false);
  useEffect(() => {
    setAmpPage(location.search?.includes('reader_id=amp'));
  }, []);

  return (
    <div styleName="subscription-wrap">
      <MobileBottomSticky isAmpPage={isAmpPage} />
      <div styleName={`overlay-div ${isMenu ? 'show' : ''}`} onClick={() => setMenu(false)}></div>
      <div className="container desktop-only" styleName="nav-section">
        <SubscriptionNavbar isOfferPage />
      </div>
      <div className="mobile-only" styleName={`nav-section ${isScrolled ? 'scrolled' : ''}`}>
        <SubscriptionNavbar isMenu={isMenu} hideShowMobileMenu={hideShowMobileMenu} isOfferPage />
      </div>
      <SubscriptionOffer isSubscriber={isSubscriber} {...props} />
      <PremiumStories sotries={premium} isSubscriber={isSubscriber} />
      <ResearchReports isSubscriber={isSubscriber} />
      <Pricing />
      <Faqs faqs={faqList} />
      <div styleName="footer" id="footer">
        <Footer isSubscription={true} />
      </div>
    </div>
  );
};

SubscriptionOfferPage.propTypes = {
  faq: PropTypes.object.isRequired,
  terms: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const subscriptionConfig = state.qt.config.subscriptions;
  const publisherConfig = state.qt.config.publisher;
  return {
    faq: subscriptionConfig.faq,
    typeFormConfig: get(publisherConfig, ['typeform'], ''),
    terms: get(state, ['qt', 'config', 'subscriptions', 'terms'], {}),
    features: get(state, ['qt', 'config', 'features'], {}),
  };
};

export default connect(mapStateToProps, null)(SubscriptionOfferPage);
